import '@popperjs/core';
import jquery from 'jquery';
import aos
    from "aos";

window.jQuery = jquery;
window.$ = jquery;
import {Modal} from 'bootstrap';
import Chart from 'chart.js/auto';
import 'lite-youtube-embed';

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
    cache: true
});

$.fn.isVisible = function () {
    let elementTop = $(this).offset().top;
    let elementBottom = elementTop + $(this).outerHeight();
    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

let utility = {
    viewable: function (e) {
        let docViewTop = $(window).scrollTop();
        let docViewBottom = docViewTop + $(window).height();
        let elemTop = $(e).offset().top;
        let elemBottom = elemTop + $(e).height();
        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    },
    chart: {
        colors:
            [
                'rgb(255, 99, 132)',
                'rgb(54, 162, 235)',
                'rgb(255, 205, 86)'
            ]
        ,
        options: {
            plugins: {
                legend: {
                    labels: {
                        color: '#333333',
                        font: {
                            family: 'DRRegular'
                        }
                    }
                }
            }
        },
        init: function (index) {
            let target = $('.chart').eq(index).attr('id');
            let heading = $('.chart-heading').eq(index).val();
            let type = $('.chart-type').eq(index).val();
            let measurement = $('.chart-measurement').eq(index).val();
            let labelData = JSON.parse($('.chart-labels').eq(index).val());
            let chartData = JSON.parse($('.chart-data').eq(index).val());
            let labels = [];
            let data = [];
            for (let labelDataKey in labelData) {
                labels.push(labelData[labelDataKey]);
            }
            for (let chartDataKey in chartData) {
                data.push(parseInt(chartData[chartDataKey]));
            }
            new Chart(
                document.getElementById(target),
                {
                    type: type,
                    labels: labels,
                    options: utility.chart.options,
                    data: {
                        labels: labels,
                        datasets: [{
                            label: heading,
                            data: data,
                            backgroundColor: utility.chart.colors,
                            hoverOffset: 4
                        }]
                    }
                }
            );
        }
    },
    count: function () {
        let duration = 15;
        let statNumber = $('.stat-number');
        let statCounter = $('.stat-counter');
        statNumber.each(function (i) {
            let max = parseFloat($(this).attr('data-value'));
            let step = Math.round(max / (max < duration ? 10 : duration));
            if (step < 1) {
                step = .07;
            }
            setTimeout(function () {
                let t = setInterval(function () {
                    let current = parseFloat(statCounter.eq(i).val());
                    let number = (step < 1 ? ((current + step).toFixed(2)).toLocaleString() : (current + step).toLocaleString());
                    if (current < max) {

                        statNumber.eq(i).html(number);
                        statCounter.eq(i).val(current + step);
                    }
                    if (current >= max) {
                        clearInterval(t);
                        statNumber.eq(i).html(max.toLocaleString());
                        statCounter.eq(i).val(max);
                    }
                }, 100);
            }, 500);
        });
    },
    image: {
        zoom: function (ElementID) {
            let $Deferred = $.Deferred();
            let $Image = $(ElementID).find('img').clone();
            $Image.removeClass('img-thumbnail');
            let Title = $Image.attr('alt');
            let Options = {
                icon: 'fa fa-image',
                closeable: true,
                title: {
                    text: Title,
                    color: 'text-white'
                },
                state: 'bg-primary',
                size: 'modal-xl'
            };
            $.when(utility.modal.open(Options)).done(function () {
                let $ModalWindowBody = $('#ModalWindowBody');
                $ModalWindowBody.addClass('text-center');
                $('#ModalWindowSaveButton').remove();
                $.when($ModalWindowBody.html($Image)).done(function () {
                    $Deferred.resolve(false);
                });
            });
        }
    },
    scroll: function (e) {
        let Deferred = new $.Deferred();
        $.when($('html').animate({
            scrollTop: (e.offset().top - 100)
        }, "slow")).done(function () {
            Deferred.resolve(true);
        });
        return Deferred.promise();
    },
    modal: {
        defaults: {
            closeable: false,
            icon: 'fa fa-info',
            title: {
                text: 'Info',
                color: 'text-white'
            },
            size: 'modal-lg',
            state: 'bg-info',
            resize: false,
            class: null,
            border: null,
            submitButtonClass: 'btn-success',
            cancelButtonClass: 'btn-secondary'
        },
        loading: function (selector) {
            selector = (selector === undefined ? $('#ModalWindowBody') : selector);
            let HTML = '<div class="text-center" style="width: 100%; margin: auto; padding: 15%;"><i class="fa fa-spinner fa-pulse fa-fw fa-5x text-primary"></i><div style="font-size: 36px;">LOADING...</div></div>';
            selector.html(HTML);
        },
        open: function (options) {
            let Deferred = new $.Deferred();
            if ($('#ModalWindowBody').length === 0) {
                options = {
                    closeable: (options.closeable !== undefined ? options.closeable : utility.modal.defaults.closeable),
                    icon: (options.icon !== undefined ? options.icon : utility.modal.defaults.icon),
                    title: {
                        text: (options.title.text !== undefined ? options.title.text : utility.modal.defaults.title.text),
                        color: (options.title.color !== undefined ? options.title.color : utility.modal.defaults.title.color),
                    },
                    size: (options.size !== undefined ? options.size : utility.modal.defaults.size),
                    state: (options.state !== undefined ? options.state : utility.modal.defaults.state),
                    resize: (options.resize !== undefined ? options.resize : utility.modal.defaults.resize),
                    class: (options.class !== undefined ? options.class : utility.modal.defaults.class),
                    border: (options.border !== undefined ? options.border : utility.modal.defaults.border),
                    submitButtonClass: (options.submitButtonClass !== undefined ? options.submitButtonClass : utility.modal.defaults.submitButtonClass),
                    cancelButtonClass: (options.cancelButtonClass !== undefined ? options.cancelButtonClass : utility.modal.defaults.cancelButtonClass),
                };
                $('#ModalWindowWrapper').load('/actions/modal/modal/open', {}, function () {
                    let $ModalWindowBody = $('#ModalWindowBody');
                    $('#ModalWindowDialog').addClass(options.size);
                    $('#ModalWindowIcon').addClass(options.icon).addClass(options.title.color);
                    $('#ModalWindowTitle').html(options.title.text).addClass(options.title.color);
                    if (options.closeable === false) {
                        $('#ModalWindowCloseButton').hide();
                    }
                    $('#ModalWindowHeader').addClass(options.state);
                    $('#ModalWindowHeader, #ModalWindowBody, #ModalWindowFooter').addClass(options.class);
                    $('#ModalWindowHeader, #ModalWindowFooter').addClass(options.border);
                    $('#ModalWindowSaveButton').addClass(options.submitButtonClass);
                    $('#ModalWindowCancelButton').addClass(options.cancelButtonClass).on('click', function () {
                        $('#ModalWindowCloseButton').trigger('click');
                    });
                    let ModalWindow = document.getElementById('ModalWindow');
                    let $Modal = new Modal(ModalWindow, {
                        backdrop: 'static',
                        keyboard: false
                    });
                    $Modal.show();
                    ModalWindow.addEventListener('hidden.bs.modal', function () {
                        $(this).remove();
                    });
                    if (options.resize === true) {
                        $ModalWindowBody.on('DOMSubtreeModified', function () {
                            utility.modal.resize($(this));
                        });
                    }
                    Deferred.resolve($ModalWindowBody);
                });
            }
            else {
                Deferred.resolve(false);
            }
            return Deferred.promise();
        },
        resize: function ($Element) {
            let ModalHeaderFooterHeight = $('#ModalWindowHeader').outerHeight() + $('#ModalWindowFooter').outerHeight();
            let y = Math.round(($(window).innerHeight() - ModalHeaderFooterHeight) / 1.4);
            $Element.height(y);
            return false;
        },
        scroll: function (selector, offset) {
            let Deferred = new $.Deferred();
            offset = (offset === undefined ? ($('#ModalWindowHeader').height() + 60) : 0);
            $('#ModalWindowBody').animate({
                scrollTop: (selector.offset().top - offset) + $(this).scrollTop()
            }, "slow", function () {
                Deferred.resolve(false);
            });
            return Deferred.promise();
        },
        video: function (selector) {
            let Deferred = new $.Deferred();
            let options = {
                icon: 'fa fa-video',
                title: {
                    text: $(selector).attr('data-title'),
                    color: 'text-white'
                },
                state: 'bg-danger',
                size: 'modal-lg'
            };
            $.when(utility.modal.open(options)).done(function () {
                $('#ModalWindowBody').load('/modal/video', function (HTML) {
                    $.when($('#ModalWindowBody').html(HTML)).done(function () {
                        $('#ModalVideoSource').attr('src', $(selector).attr('data-target'));
                        Deferred.resolve(false);
                    });
                });
                $('#ModalWindowSaveButton').remove();
                return Deferred.promise();
            });
        },
        content: function (selector) {
            let Deferred = new $.Deferred();
            let options = {
                icon: 'fa',
                title: {
                    text: null,
                    color: 'text-white'
                },
                state: 'bg-danger',
                size: 'modal-lg',
                closeable: true
            };
            let url = $(selector).prop('href');
            $.when(utility.modal.open(options)).done(function () {
                $('#ModalWindowSaveButton, #ModalWindowIcon').remove();
                $('#ModalWindowBody').load(url, function (HTML) {
                    $.when($('#ModalWindowBody').html(HTML)).done(function () {
                        let img = '<img src="' + $('#ContentIcon').val() + '" style="height: 32px; width: auto;" alt="img"/>';
                        $('#ModalWindowTitle').html(img);
                        Deferred.resolve(false);
                    });
                }).css({
                    height: '70vh',
                    overflow: 'auto'
                });
                return Deferred.promise();
            });
        }
    }
}

let dr = {
    init: function () {
        aos.init({
            once: true,
            disable: function () {
                return /bot|googlebot|insights|inspection|crawler|spider|robot|lighthouse|crawling/i.test(navigator.userAgent);
            }
        });
        utility.count();
        let c = dr.cookie.get('HideAlert');
        let $SiteAlert = $('#SiteAlert');
        if ($SiteAlert.length > 0 && c !== 'true') {
            $SiteAlert.fadeIn();
        }
        $('.alert-dismiss').on('click', function () {
            document.cookie = 'HideAlert=true';
        });
        let $Window = $(window);
        $Window.on('scroll resize load', function () {
            if ($(window).scrollTop() > 1) {
                dr.menu.light();
            }
            else {
                dr.menu.dark();
            }
        });
        $('.phone-link').on('click', function () {
            gtag('event', 'phone_call', {
                'event_category': 'Conversion',
                'event_label': window.location.pathname,
                'link_url': $(this).attr('href')
            });
        });
        $('.book-link').on('click', function () {
            gtag('event', 'click', {
                'event_category': 'Conversion',
                'event_label': window.location.pathname,
                'link_url': $(this).attr('href')
            });
        });
        $('.accordion-button').on('click', function () {
            gtag('event', 'select_content', {
                'content_type': this.text,
                'content_id': window.location.pathname
            });
        });
        $('.service-info').on('click', function (e) {
            e.preventDefault();
            dr.plan.info(this);
        });
        $('.link-newsletter-subscribe').on('click', function (e) {
            e.preventDefault();
            dr.newsletter.subscribe();
        });
        if ($('#RoiCalculatorForm').length > 0) {
            dr.roi.init();
            utility.count();
        }
        if ($('#HeroVideo').length > 0) {
            document.getElementById('HeroVideo').play();
        }
        $('.chart').each(function (i) {
            utility.chart.init(i);
        });
        $('.img-zoom').on('click', function (e) {
            e.preventDefault();
            return utility.image.zoom(this);
        });

        $('#BlogSortSelect').on('change', function () {
            $('#BlogSortForm').submit();
        });

        function wrapFortrabbit(node) {
            if (node.nodeType === 3) { // Text node
                let replacedText = node.nodeValue.replace(/(fortrabbit)/gi, '<span class="fortrabbit">$1</span>');
                if (replacedText !== node.nodeValue) {
                    let wrapper = document.createElement('span');
                    wrapper.innerHTML = replacedText;
                    node.parentNode.replaceChild(wrapper, node);
                }
            }
            else if (node.nodeType === 1 && !$(node).hasClass('fortrabbit') && node.tagName !== 'SCRIPT' && node.tagName !== 'STYLE') {
                $(node).contents().each(function () {
                    wrapFortrabbit(this);
                });
            }
        }

        if (window.location.href.includes('hosting')) {
            wrapFortrabbit(document.body);
        }
    },
    newsletter: {
        subscribe: function () {
            $.ajax('', {
                type: 'GET',
                dataType: 'JSON',
                data: {
                    action: '/form/form/subscribe-form'
                }
            }).done(function (Response) {
                let options = {
                    icon: 'fa-duotone fa-info-circle',
                    title: {
                        text: "Subscribe to Our Blog Posts",
                        color: 'text-white'
                    },
                    state: 'bg-primary',
                    size: 'modal-md',
                    closeable: true
                };
                $.when(utility.modal.open(options)).done(function () {
                    $('#ModalWindowSaveButton').html('Subscribe');
                    $('#ModalWindowCancelButton').html('Cancel');
                    $.when($('#ModalWindowBody').html(Response.HTML)).done(function () {
                        $.when(dr.recaptcha.load()).done(function () {
                            dr.form.init('ModalWindowForm');
                            setTimeout(function () {
                                $('#ContactEmail').focus();
                            }, 1500);
                        });
                    });
                });
            });
        }
    },
    plan: {
        info: function (item) {
            let service = $(item).attr('data-service');
            let info = $(item).attr('data-info');
            let options = {
                icon: 'fa fa-info-circle',
                title: {
                    text: service,
                    color: 'text-white'
                },
                state: 'bg-primary',
                size: 'modal-lg',
                closeable: true
            };
            $.when(utility.modal.open(options)).done(function () {
                $('#ModalWindowSaveButton').remove();
                $('#ModalWindowBody').html(info);
            });
        }
    },
    recaptcha: {
        load: function () {
            let $Deferred = $.Deferred();
            if ($('#GoogleRecaptcha').length > 0) {
                $.getScript('https://www.google.com/recaptcha/api.js?render=explicit', function () {
                    let t = setInterval(function () {
                        if (typeof grecaptcha.render === 'function') {
                            clearInterval(t);
                            grecaptcha.render('GoogleRecaptcha', {
                                'sitekey': $('#GCKey').val()
                            });
                            $Deferred.resolve(true);
                        }
                    }, 100);
                });
            }
            else {
                $Deferred.resolve(true);
            }
            return $Deferred.promise();
        },
        validate: function () {
            let Response = true;
            if ($('#GoogleRecaptcha').length > 0) {
                let r = grecaptcha.getResponse()
                if (r.length === 0) {
                    Response = false;
                }
            }
            return Response;
        }
    },
    cookie: {
        get: function (name) {
            let cookie = {};
            document.cookie.split(';').forEach(function (el) {
                let [k, v] = el.split('=');
                cookie[k.trim()] = v;
            });
            return cookie[name];
        }
    },
    menu: {
        dark: function () {
            let $Nav = $('nav');
            let $DropDownMenu = $('.dropdown-menu');
            let $NavLink = $('.nav-link, .dropdown-item');
            let $LogoLight = $('.logo-light');
            let $LogoDark = $('.logo-dark');
            let $SocialLink = $('.social-link');
            let $BookLink = $('.book-link');
            $Nav.addClass('bg-primary navbar-dark').removeClass('bg-white navbar-light');
            $DropDownMenu.addClass('dropdown-menu-dark bg-primary').removeClass('bg-white');
            $NavLink.addClass('text-white').removeClass('text-primary');
            $SocialLink.addClass('text-white').removeClass('text-primary');
            $BookLink.addClass('btn-outline-info').removeClass('btn-outline-primary');
            $LogoDark.hide();
            $LogoLight.show();
        },
        light: function () {
            let $Nav = $('nav');
            let $DropDownMenu = $('.dropdown-menu');
            let $NavLink = $('.nav-link, .dropdown-item');
            let $LogoLight = $('.logo-light');
            let $LogoDark = $('.logo-dark');
            let $SocialLink = $('.social-link');
            let $BookLink = $('.book-link');
            $Nav.removeClass('bg-primary navbar-dark').addClass('bg-white navbar-light');
            $DropDownMenu.removeClass('dropdown-menu-dark bg-primary').addClass('bg-white');
            $NavLink.removeClass('text-white').addClass('text-primary');
            $SocialLink.addClass('text-primary').removeClass('text-white');
            $BookLink.addClass('btn-outline-primary').removeClass('btn-outline-info');
            $LogoDark.show();
            $LogoLight.hide();
        }
    },
    consultation: {
        init: function () {
            $.when(dr.recaptcha.load()).done(function () {
                dr.form.init('ConsultationForm');
            });
        }
    },
    form: {
        init: function (FormID) {
            let form = document.getElementById(FormID);
            if ($('#AutoScrollForm').val() > 0) {
                utility.scroll($('#' + FormID));
            }
            form.addEventListener('submit', function (event) {
                event.preventDefault();
                let grv = dr.recaptcha.validate();
                if (form.checkValidity() === false || grv === false) {
                    event.stopPropagation();
                    if (grv === false) {
                        $('#GoogleRecaptcha').addClass('border border-danger');
                    }
                }
                else {
                    dr.form.submit(FormID);
                }
                if (grv === true) {
                    $('#GoogleRecaptcha').removeClass('border border-danger');
                }
                form.classList.add('was-validated');
            }, false);
        },
        submit: function (FormID) {
            let Deferred = new $.Deferred();
            $('.btn-submit').attr('disabled', 'disabled').html('<i class="fa fa-spinner fa-spin"></i>');
            $.ajax('', {
                type: 'POST',
                dataType: 'JSON',
                data: $('#' + FormID).serialize()
            }).done(function (Response) {
                $('.btn-submit').removeAttr('disabled').html('Done!');
                let Options = {
                    icon: 'fa fa-info-circle',
                    title: {
                        text: 'Thank You' + (typeof Response.Data.Contact.FirstName !== 'undefined' ? ', ' + Response.Data.Contact.FirstName : null),
                        color: 'text-white'
                    },
                    state: 'bg-primary',
                    size: 'modal-lg'
                };
                $.when(utility.modal.open(Options)).done(function () {
                    $('#ModalWindowSaveButton').remove();
                    $.when($('#ModalWindowBody').html(Response.HTML)).done(function () {
                        let redirect = '/';
                        let $FormEventCategory = $('#FormEventCategory');
                        let $FormRedirect = $('#FormRedirect');
                        if (Response.Data.SendMail.ErrorCode === 0) {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                event: 'generate_lead',
                                formId: 'lead-gen',
                                formType: $FormEventCategory.length > 0 ? $FormEventCategory.val() : window.location.title,
                                submittedAt: new Date().toISOString()
                            });
                            redirect = $FormRedirect.length > 0 ? $FormRedirect.val() : '/';
                        }
                        $('#ModalWindowCancelButton').html('Close').on('click', function () {
                            $('#ModalWindowCloseButton').trigger('click');
                            window.location = redirect;
                        });
                        Deferred.resolve(false);
                    });
                });
            });
            return Deferred.promise();
        }
    },
    roi: {
        init: function () {
            let defaults = {
                visits: 1000,
                conversions: 21,
                falloff: 15,
                value: 100,
                spend: 750.00
            }
            let form = document.getElementById('RoiCalculatorForm');
            let $Visits = $('#WebsiteVisits');
            let $Conversions = $('#Conversions')
            let $Falloff = $('#ConversionFalloff');
            let $Value = $('#ConversionValue');
            let $Spend = $('#WebsiteSpend');
            $Visits.val(defaults.visits);
            $Conversions.val(defaults.conversions);
            $Falloff.val(defaults.falloff);
            $Value.val(defaults.value);
            $Spend.val(defaults.spend);
            form.addEventListener('submit', function (event) {
                event.preventDefault();
                $('.stat-counter').val(0);
                if (form.checkValidity() === false) {
                    event.stopPropagation();
                }
                else {
                    dr.roi.submit();
                }
                form.classList.add('was-validated');
            });
        },
        submit: function () {
            let $WebsiteVisits = $('#ResultsWebsiteVisits');
            let $Conversions = $('#ResultsConversions');
            let $ConversionsActual = $('#ResultsConversionFalloff');
            let $ConversionValue = $('#ResultsConversionValue');
            let $Spend = $('#ResultsSpend');
            let $ConversionPercent = $('#ConversionPercent');
            let $RoiPercent = $('#RoiPercent');
            $WebsiteVisits.html(0);
            $Conversions.html(0);
            $ConversionsActual.html(0);
            $ConversionValue.html(0);
            $Spend.html(0);
            $ConversionPercent.attr('data-value', 0);
            $RoiPercent.attr('data-value', 0);
            $.ajax('', {
                type: 'POST',
                dataType: 'JSON',
                data: $('#RoiCalculatorForm').serialize()
            }).done(function (Response) {
                $.when(utility.scroll($('#CalculatorROIResults'))).done(function () {
                    let $FormEventCategory = $('#FormEventCategory');
                    let percentclass = (Response.Data.negative === true ? "text-danger" : "text-success");
                    $WebsiteVisits.html(Response.Data.visits);
                    $Conversions.html(Response.Data.conversions);
                    $ConversionsActual.html(Response.Data.conversionFalloff);
                    $ConversionValue.html(Response.Data.conversionValue);
                    $Spend.html(Response.Data.spend);
                    $ConversionPercent.attr('data-value', Response.Data.conversionPercent);
                    $RoiPercent.attr('data-value', Response.Data.roiPercent).parent().removeClass('text-danger text-success').addClass(percentclass);
                    utility.count();
                    gtag('event', 'roi_calculate', {
                        'event_category': $FormEventCategory.length > 0 ? $FormEventCategory.val() : window.location.title,
                        'event_label': window.location.pathname
                    });
                });
            });
        }
    }
}

$(function () {
    dr.init();
    if ($('#ConsultationForm').length > 0) {
        dr.consultation.init();
    }
});